/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* CODE OF TERMS & CONDITION CHECKBOX START */
// document.addEventListener("DOMContentLoaded", function() {
//     document.querySelectorAll('[name="checkout"], [name="goto_pp"], [name="goto_gc"]').forEach(item => {
//         console.log("hello")
//         item.addEventListener('click', event => {
//             console.log(event);
//             if (document.querySelector('#agree').checked) {
//                 document.querySelector(event).submit();
//             }
//             else {
//                 alert("Du skal acceptere handelsbetingelserne for at gå til betaling.");
//                 return false;
//             }
//         })
//       })
// });
/* CODE OF TERMS & CONDITION CHECKBOX END */

document.addEventListener("DOMContentLoaded", function() {
    const upsaleItems = document.querySelectorAll('.upsale');
    upsaleItems.forEach((upsaleItem) => {
        const upsaleBtn = upsaleItem.querySelector('.upsale--btn')
        
        upsaleBtn.addEventListener('click', (event) => {
            event.preventDefault();
            document.dispatchEvent(new CustomEvent('theme:loading:start'));
            fetch("".concat(window.routes.cartAddUrl, ".js"), {
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                },
                body: JSON.stringify({
                    upsale: true,
                    id: upsaleBtn.dataset.productId,
                    quantity: 1
                })
            }).then(async function (response) {
                document.dispatchEvent(new CustomEvent('theme:loading:end'));
                if(response.ok) {
                    const data = await response.json();
                    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                        bubbles: true,
                        detail: {
                            variant: data,
                            quantity: 1
                        }
                    }));
    
                    document.documentElement.dispatchEvent(new CustomEvent('product:showAlert', {
                        detail: {
                            message: window.languages.productAdded,
                            type: 'success',
                            afterElement: upsaleBtn
                        } 
                    }))
                    
                    ga('send', {
                        hitType: 'event',
                        eventCategory: 'Upsale Product',
                        eventAction: 'Add',
                        eventLabel: data.title,
                        eventValue: parseInt(Currency.formatMoney(data.price, '{{amount}}'))
                    });
                }
            })
        })
    })
});

// window.onscroll = function() {myFunction()};

// // Get the navbar
// var navbar = document.querySelector('.nav-bar');

// // Get the offset position of the navbar
// var sticky = navbar.offsetTop;

// // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
// function myFunction() {
//   if (window.pageYOffset >= sticky) {
//     navbar.classList.add("sticky")
//   } else {
//     navbar.classList.remove("sticky");
//   }
// }

// document.addEventListener("DOMContentLoaded", function() {
//     if(screen.width > 1000) {
//         const headerSectionSettings = JSON.parse(document.querySelector('[data-section-type="header"]').getAttribute('data-section-settings'));
//         if(headerSectionSettings.useStickyHeader && headerSectionSettings.useStickyNavDesktop) {
//             // const headerDiv = document.getElementById('shopify-section-header');
//             // const navDiv = document.querySelector('.nav-bar');
//             // headerDiv.style.position = "relative";
//             // headerDiv.style.top = "unset";

// document.addEventListener("DOMContentLoaded", function() {
//     if(screen.width > 1000) {
//         const headerSectionSettings = JSON.parse(document.querySelector('[data-section-type="header"]').getAttribute('data-section-settings'));
//         if(headerSectionSettings.useStickyHeader && headerSectionSettings.useStickyNavDesktop) {
//             // const headerDiv = document.getElementById('shopify-section-header');
//             // const navDiv = document.querySelector('.nav-bar');
//             // headerDiv.style.position = "relative";
//             // headerDiv.style.top = "unset";

//             // navDiv.style.position = "sticky";
//             // navDiv.style.top = "0";
//             // document.documentElement.style.setProperty('--header-height', navDiv.clientHeight + 'px');
//         }
        
//         console.log(headerSectionSettings);
//     }

// });

// var lastScrollTop = 0;

// // element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
// document.addEventListener("scroll", function(){ // or window.addEventListener("scroll"....
//    var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
//    if (st > lastScrollTop){
//       // downscroll code
//    } else {
//       // upscroll code
//    }
//    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
// }, false);


// Adding text behind reviews section
const reviewsCountElement = document.querySelector('a.link.underlined-link');

if(reviewsCountElement != null) {
    reviewsCountElement.querySelector('span').remove();
    const reviewsCount = parseInt(reviewsCountElement);
    if(reviewsCount == 1) {
        document.querySelector('a.link.underlined-link').innerHTML += " anmeldelse";
    } else {
        document.querySelector('a.link.underlined-link').innerHTML += " anmeldelser"
    }
}
